import React, { useState, useCallback, DragEvent } from 'react';
//libs
import { FieldError, useFormContext, useWatch } from 'react-hook-form';
import { useDropzone } from 'react-dropzone';
// styles
import cn from 'classnames/bind';
import styles from './field.module.css';
//icons
import BinIcon from '../../../images/career/bin.inline.svg';
import { watchFile } from 'fs';

const cx = cn.bind(styles);

export interface InputFieldProps {
  name: string;
  error?: FieldError;
  file?: FileList | undefined | null;
}

const ACCEPTED_FILE_EXTENSIONS = [
  'application/pdf',
  'application/msword',
  '.doc',
  '.docx',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
];

function DropField({ name, error, file }: InputFieldProps) {
  const { setValue, control } = useFormContext();
  const fileWatch = useWatch({ name, control });

  const [isFileAvailable, setFileAvailable] = useState(false);

  const fileSizeValidator = (files: File[]) => {
    const acceptableSize = 5 * 1024 * 1024;

    if (files[0].size > acceptableSize) {
      console.log('File size exceeds acceptable size');
      setFileAvailable(false);
    } else {
      setValue(name, files);
      setFileAvailable(true);
    }
  };

  const onDrop = useCallback((acceptedFiles) => {
    acceptedFiles.forEach((file: File) => {
      const reader = new FileReader();

      reader.onload = () => {
        fileSizeValidator(acceptedFiles);
      };
      reader.readAsArrayBuffer(file);
    });
  }, []);

  const { getRootProps, getInputProps, isDragActive, acceptedFiles } = useDropzone({
    onDrop,
    accept: ACCEPTED_FILE_EXTENSIONS.join(','),
    multiple: false,
  });

  function removeFiles(e: DragEvent | Event) {
    setFileAvailable(false);
    e.stopPropagation();
  }

  return (
    <div className={styles.dragContainer}>
      <div {...getRootProps()}>
        <div className={isDragActive ? styles.dragFieldActive : styles.dragField}>
          {isFileAvailable && !!fileWatch && acceptedFiles?.length > 0 ? (
            <div className={styles.askUpload}>
              <ul>
                {acceptedFiles.map(({ name }) => (
                  <li key={name}>
                    <p className={styles.fileName}>{name}</p>
                  </li>
                ))}
              </ul>
              <BinIcon
                className={styles.binIcon}
                onClick={(e: DragEvent | Event) => removeFiles(e)}
              />
            </div>
          ) : (
            <p className={styles.askUpload}>Upload Your CV</p>
          )}

          <input
            {...getInputProps({ onDrop })}
            name={name}
            type="file"
            accept={ACCEPTED_FILE_EXTENSIONS.join(',')}
          />

          <p className={styles.unloadedFile}>
            *File up to 5MB. Accepted formats: .pdf, .doc, .docx.
          </p>
        </div>
      </div>

      <div className={cx('errorText', { visible: !!error?.message })}>{error?.message}</div>
    </div>
  );
}
export default DropField;
